export default "__VITE_ASSET__9Az05FL3__"